import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Details")

import { Node } from "@/api/node-lookup";
import AppDetail from "@/components/AppDetail.vue";
import AppDetails from "@/components/AppDetails.vue";

interface Props {
  /** current node */
  node: Node;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionDetails',
  props: {
    node: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppLink = _resolveComponent("AppLink")!
  const _component_AppFlex = _resolveComponent("AppFlex")!
  const _component_AppSection = _resolveComponent("AppSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_AppSection, null, {
    default: _withCtx(() => [
      _createVNode(_component_AppHeading, { icon: "clipboard-list" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(AppDetails, null, {
        default: _withCtx(() => [
          _createVNode(AppDetail, {
            blank: !__props.node.iri,
            title: "IRI"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppLink, {
                to: __props.node.iri
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.node.iri.split("/").pop()), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _: 1
          }, 8, ["blank"]),
          _createVNode(AppDetail, {
            blank: !__props.node.inheritance.length,
            title: "Heritability"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppFlex, {
                "h-align": "left",
                gap: "small"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.node.inheritance, (inheritance, index) => {
                    return _withDirectives((_openBlock(), _createBlock(_component_AppLink, {
                      key: index,
                      to: inheritance.link
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(inheritance.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])), [
                      [_directive_tooltip, inheritance.id]
                    ])
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["blank"]),
          _createVNode(AppDetail, {
            blank: !__props.node.modifiers.length,
            title: "Clinical Modifiers"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(__props.node.modifiers.join("  |  ")), 1)
            ]),
            _: 1
          }, 8, ["blank"]),
          (__props.node.category === 'gene')
            ? (_openBlock(), _createBlock(AppDetail, {
                key: 0,
                blank: !__props.node.taxon?.id,
                title: "Taxon"
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_AppLink, {
                    to: __props.node.taxon?.link || ''
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.node.taxon?.name), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])), [
                    [_directive_tooltip, __props.node?.taxon?.id]
                  ])
                ]),
                _: 1
              }, 8, ["blank"]))
            : _createCommentVNode("", true),
          _createVNode(AppDetail, {
            blank: !__props.node.xrefs.length,
            title: "External References",
            big: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppFlex, {
                "h-align": "left",
                gap: "small"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.node.xrefs, (xref, index) => {
                    return (_openBlock(), _createBlock(_component_AppLink, {
                      key: index,
                      to: xref.link
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(xref.id), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["blank"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})